<template>
  <v-card class="elevation-0">
    <v-card-text class="pa-0">
      <v-data-table
        :headers="headers"
        :items="formattedItems"
        :no-data-text="$t('texts.noCompaniesAddedYet')"
        hide-default-header
        hide-default-footer
      >
        <template v-slot:item.actions="{ item }">
          <v-btn
            v-if="isCurrentlyCancellable && !item.is_cancelled"
            small outlined depressed
            color="red"
            style="height: 24px;"
            @click="showCancelSubscriptionDialog({
              subscription_id: subscriptionId,
              company_id: subscriptionCompanyId,
              company_name: item.name,
              additional_company_id: item.id,
              next_possible_cancellation_date: nextPossibleCancellationDate,
              type: 'additional',
            })"
          >
            {{ $t('texts.terminate') }}
          </v-btn>
          <v-chip
            v-if="item.is_cancelled"
            label small disabled
            color="red" text-color="white"
          >
            {{ $t('texts.terminated') }}
          </v-chip>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'AdditionalCompaniesDatatable',
  props: {
    companies: {
      type: Array,
    },
    stripe_plan: {
      type: String,
    },
    subscriptionId: {
      type: Number,
    },
    subscriptionCompanyId: {
      type: Number,
    },
    isCurrentlyCancellable: {
      type: Boolean,
      default: false,
    },
    nextPossibleCancellationDate: {
      type: String,
    },
    showCancelSubscriptionDialog: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      dataLoaded: true,
      headers: [
        { text: 'Name', value: 'formattedNamePlace' },
        { text: '', value: 'actions' },
      ],
    };
  },
  computed: {
    formattedItems() {
      if (this.companies.length > 0) {
        return this.companies.map((item) => {
          const formattedNamePlace = `${item.name}, ${item.place}`;
          return {
            formattedNamePlace,
            ...item,
          };
        });
      }
      return [];
    },
  },
};
</script>
